/* eslint-disable */
import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import labelGeneratorServices from '../../../Services/labelGeneratorServices';
import { notificationServices } from '../../../Services';
import ImagesFinder from '../../ImagesFinder/ImagesFinder';
import { ListTable } from '../../ListTable';
import { modalActions } from '../../../Actions';
import styles from './SavedLabels.module.scss';
// import LabelGenerator from '../../../Pages/LabelGenerator/LabelGenerator';
import { urls } from '../../../Constants';
import labelGeneratorConfig from '../LabelGenerator.config';
import { useAuth } from '@/Components/Auth/Login/auth';
import { Pencil, Trash2 } from 'lucide-react';

const TABLE_COLUMNS = [
	{
		title: 'Label Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Label Size',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Label Type',
		config: {
			type: 'DATA',
		},
	},
];

const excludedColumns = [];
const colMap = {
	'Label Name': 'name',
	'Label Size': 'size',
	'Label Type': 'type',
};

const DPMM = 8;
const dotsToMm = (d) => Math.round((Number(d) || 0) / DPMM);
const getLabelSize = (label) => {
	const zpl = label?.zplCode || '';
	const pw = /\^PW\s*(\d+)/i.exec(zpl);
	const ll = /\^LL\s*(\d+)/i.exec(zpl);
	const width = (pw && dotsToMm(pw[1])) || label?.size?.width || 0;
	const height = (ll && dotsToMm(ll[1])) || label?.size?.height || 0;
	return `${width}x${height}`;
};

function SavedLabels(props) {
	const { toggleAlert } = props;
	const history = useHistory();
	const [savedLabels, setSavedLabels] = useState([]);
	const [isLoading, setIsLoading] = useState();
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const { userRolesDict } = userConfig || {};
	const isInternal = Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') || Object?.values?.(userRolesDict ?? {}).includes('Config Admin') || Object?.values?.(userRolesDict ?? {}).includes('Internal');
	const handleSavedLabelsAPI = async () => {
		setIsLoading(true);
		try {
			const response = await labelGeneratorServices.getLabels();
			if (response?.statusCode === 200) {
				const result = response?.savedLabels;
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				setSavedLabels(
					result
						?.filter((ele) => {
							return ele?.customerId;
						})
						?.map((ele) => {
							return {
								key: ele?.id,
								id: ele?.id,
								size: ele?.label?.size,
								name: ele?.labelName,
								label: ele?.label?.components,
								type: ele?.labelType,
								printCount: ele?.printCount,
								zplCode: ele?.zplCode,
							};
						})
				);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			notificationServices.generateNotification({
				type: 'error',
				message: 'Unable to fetch labels, please connect with UY Team',
			});
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		handleSavedLabelsAPI();
	}, []);

	const handleDeleteLabelAPI = async (val) => {
		setIsLoading(true);
		try {
			const response = await labelGeneratorServices.deleteLabel(val);
			if (response?.statusCode === 200) {
				handleSavedLabelsAPI();
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Unable to delete, please connect with UY Team',
			});
		} finally {
			setIsLoading(false);
		}
	};

	const deleteLabel = async (val) => {
		setIsLoading(true);
		try {
			await handleDeleteLabelAPI(val);
			setSavedLabels(
				savedLabels.filter((component) => {
					return component?.id !== val;
				})
			);
		} finally {
			setIsLoading(false);
		}
	};

	const openLabel = (val) => {
		const currLabel = savedLabels.find((label) => {
			return label.key === val;
		});
		history.push(`${urls.EXTENSION}${urls.LABEL_GENERATOR_CREATE}`, { currLabel: currLabel });

		// setLabelComponentsState(currLabel?.label);
		// setBackButtonClicked(true);
		// setLabelDetails({
		// key: currLabel?.key,
		// id: currLabel?.id,
		// size: currLabel?.size,
		// name: currLabel?.name,
		// type: currLabel?.type,
		// });
		// setLabelType(currLabel?.type);
		// handleBackButtonApp('back-button');
	};

	const ACTION_COLUMNS = [
		{
			title: 'Actions',
			config: {
				type: 'DATA',
			},
		},
	];

	const SPECIAL_ITEMS = {
		'Label Type': (labelType) => {
			const type = labelGeneratorConfig?.namingOfMachineType?.[labelType];
			return (
				type
			);
		},
		Actions: (labelId) => {
			const selectedLabel = savedLabels.find((label) => {
				return label.id === labelId;
			});
			return (
				<div className={styles?.actions}>
					{isInternal && (
						<span
							title='Edit'
							className='cursor-pointer inline-flex items-center justify-center rounded-md p-1.5 bg-blue-50 hover:bg-blue-100 text-blue-600'
							onClick={() => {
								openLabel(labelId);
							}}
						>
							<Pencil size={18} />
						</span>
					)}
					<span
						title='Delete'
						className='cursor-pointer inline-flex items-center justify-center rounded-md p-1.5 bg-red-50 hover:bg-red-100 text-red-600'
						onClick={() => {
							toggleAlert(true, {
								heading: 'Delete Label?',
								handleConfirm: () => {
									deleteLabel(labelId);
									toggleAlert(false);
								},
								colorReverse: false,
								cancelText: 'No',
								confirmText: 'Yes',
								message: `Are you sure you want to delete ${selectedLabel?.name}?`,
							});
						}}
					>
						<Trash2 size={18} />
					</span>
				</div>
			);
		},
	};

	const handleAddClick = () => {
		history.push(`${urls.EXTENSION}${urls.LABEL_GENERATOR_CREATE}`);
	};

	return (
		<div className={styles.root}>
			<div className={styles.header}>
				<div className='flex justify-between p-2  '>
					<span className='font-bold text-[16px]'>Label Generator</span>
					{level !== 1 && (
						<Button
							onClick={handleAddClick}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ Create New Label
						</Button>
					)}
				</div>
			</div>
			<div className='max-h-[calc(100vh-200px)] overflow-auto'>
				<ListTable
					colMap={colMap}
					columns={TABLE_COLUMNS?.filter((ele) => {
						return !excludedColumns?.includes(ele?.title);
					})}
					actions={level !== 1 ? [...ACTION_COLUMNS] : []}
					data={savedLabels?.map((ele) => {
						return {
							...ele,
							// ZPL (^PW/^LL) se calculated size; na mile to stored size
							size: getLabelSize(ele),
						};
					})}
					special={{
						...SPECIAL_ITEMS,
					}}
					showBtnContainer={false}
					allowExport={false}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = {
	toggleAlert: modalActions.toggleAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedLabels);
